import { useCallback, useContext } from 'react';
import toast from 'Utils/toast';
import UserContext from 'Shared/UserContext';
import { setNetworkOFF, setNetworkON } from 'Shared/UserContext/Actions';
import history from 'config/history';
import { JWE_KEY } from 'Utils/crypt';
import formatErrorMessage from 'config/errorMessages';

export default function useNetworkLoader() {
  const {
    dispatch,
  } = useContext(UserContext);

  const on = useCallback(() => dispatch(setNetworkON()), []);
  const off = useCallback(() => dispatch(setNetworkOFF()), []);
  const callApi = useCallback(async (api, callBack, loader = true, onError) => {
    try {
      if (loader) {
        on();
      }
      const data = await api();
      callBack(data);
    } catch (e) {
      if (e?.handled) return;
      console.error(e);
      if (e?.message === 'no key found' || e?.message === 'JWE key not found in localStorage') {
        console.warn('[AUTH] forcing logout from useNetworkLoader:', e.message);
        localStorage.removeItem('token');
        localStorage.removeItem(JWE_KEY);
        toast.info('Votre session a expiré, veuillez vous reconnecter.', { toastId: 'session-expired' });
        history.push('/login');
      } else {
        const message = e?.response?.data?.statusLabel;
        if (message) toast.error(formatErrorMessage(message));
      }
      if (onError) onError(e);
    } finally {
      if (loader) {
        off();
      }
    }
  }, []);
  return {
    on,
    off,
    callApi,
  };
}
